module.exports = __webpack_public_path__ + "a0bf970f.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/viber_icon.png
// module id = 2071
// module chunks = 15 17 32 36